export default "__VITE_ASSET__CsT7y3XE__"